var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"battery-usage-chart-container",staticClass:"battery-usage-chart-container"})}
var staticRenderFns = []

export { render, staticRenderFns }